var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiple-select-input-field',{attrs:{"value":_vm.mappedValue,"options":_vm.vehicleOptions,"disabled":_vm.disabled,"id":"vehicles","placeholder":"Auto hinzufügen"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }